// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2pZKr","imageUploader":"EGiftCard_imageUploader__lPWS3"};